//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets Mail settings for a subtenant.
 */
export function getSubtenantSettings(subtenantId: number, config?: AxiosRequestConfig | undefined): Promise<Types.SmtpSubtenantSettingsDto> {
    let url_ = getBaseUrl() + "/api/mail/settings/smtp/{subtenantId}";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetSubtenantSettings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetSubtenantSettings?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetSubtenantSettings(_response);
    });
}

function processGetSubtenantSettings(response: AxiosResponse): Promise<Types.SmtpSubtenantSettingsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initSmtpSubtenantSettingsDto(resultData200);
        return Promise.resolve<Types.SmtpSubtenantSettingsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SmtpSubtenantSettingsDto>(null as any);
}

/**
 * Patches Mail settings for a subtenant.
 */
export function patchSubtenantSettings(subtenantId: number, dto: Types.SmtpSubtenantSettingsPatchDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/mail/settings/smtp/{subtenantId}";
    if (subtenantId === undefined || subtenantId === null)
      throw new Error("The parameter 'subtenantId' must be defined.");
    url_ = url_.replace("{subtenantId}", encodeURIComponent("" + subtenantId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeSmtpSubtenantSettingsPatchDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchSubtenantSettings,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchSubtenantSettings?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchSubtenantSettings(_response);
    });
}

function processPatchSubtenantSettings(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Send the test email to check SMTP settings.
 * @param subtenantId (optional) 
 * @param email (optional) Recipient email
 */
export function sendTestMessage(subtenantId?: number | undefined, email?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/mail/settings/smtp/send-test-message?";
    if (subtenantId === null)
        throw new Error("The parameter 'subtenantId' cannot be null.");
    else if (subtenantId !== undefined)
        url_ += "subtenantId=" + encodeURIComponent("" + subtenantId) + "&";
    if (email === null)
        throw new Error("The parameter 'email' cannot be null.");
    else if (email !== undefined)
        url_ += "email=" + encodeURIComponent("" + email) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendTestMessage,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendTestMessage?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendTestMessage(_response);
    });
}

function processSendTestMessage(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetSubtenantSettings: Partial<AxiosRequestConfig> | null;
export function getGetSubtenantSettingsRequestConfig() {
  return _requestConfigGetSubtenantSettings;
}
export function setGetSubtenantSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetSubtenantSettings = value;
}
export function patchGetSubtenantSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetSubtenantSettings = patch(_requestConfigGetSubtenantSettings ?? {});
}

let _requestConfigPatchSubtenantSettings: Partial<AxiosRequestConfig> | null;
export function getPatchSubtenantSettingsRequestConfig() {
  return _requestConfigPatchSubtenantSettings;
}
export function setPatchSubtenantSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchSubtenantSettings = value;
}
export function patchPatchSubtenantSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchSubtenantSettings = patch(_requestConfigPatchSubtenantSettings ?? {});
}

let _requestConfigSendTestMessage: Partial<AxiosRequestConfig> | null;
export function getSendTestMessageRequestConfig() {
  return _requestConfigSendTestMessage;
}
export function setSendTestMessageRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendTestMessage = value;
}
export function patchSendTestMessageRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendTestMessage = patch(_requestConfigSendTestMessage ?? {});
}